import * as React from 'react';
import * as _ from 'lodash';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Label, SectionTitle, Title } from '../../common/baseComponents';
import { DealerLabel, MainSideBarContainer, MenuContainer, IconContainer, IconAnimation } from './styles';
import { useLocation } from 'react-router';
import { RootState } from 'store/types';
import { Dealer } from 'features/Dealers/DealerSelect/state/types';
import PlatformMenu from '../Menu';
import CollapseIcon from 'common/icons/collapseIcon';

export interface SideBarProps {
    collapse: boolean
    onCollapseClick: (b: boolean) => void     
    hideSearch: (hide: boolean) => void;
}

const SideBar = (props: SideBarProps) => {

    const location = useLocation();

    const { dealers, selectedDealer } = useSelector((state: RootState) => {
        return {
            dealers: state.dealers.dealer.dealers,
            selectedDealer: state.dealers.dealer.selectedDealer
        }
    })
    const dealerName = React.useMemo(() => {
        if (selectedDealer) {
            return selectedDealer.name
        }
        const dealerId = new URLSearchParams(location.search).get("dealer")
        if (dealers) {
            const dealerFound: Dealer | undefined = dealers.find(d => d.id === dealerId)
            return dealerFound?.name
        }
        return undefined

    }, [location.search, dealers])


    return (
        <MainSideBarContainer collapse={props.collapse}>
            <IconContainer onClick={() => props.onCollapseClick(!props.collapse)}>
               <IconAnimation collapse={props.collapse}>
                   <CollapseIcon/>
               </IconAnimation>
            </IconContainer>

            <MenuContainer>
                <PlatformMenu collapse={props.collapse} hideSearch={props.hideSearch}/>
            </MenuContainer>

        </MainSideBarContainer>
    )

}

export default SideBar;